import { defineComponent as _defineComponent } from 'vue'

import * as myUseStore from "@/store/useStore";
const myStore = myUseStore.default();

const __default__ = {
  metaInfo: {
    title: `${myStore.appConfig.brandTagline} | ${myStore.appConfig.brandName}`,
    meta: [
      {
        name: "description",
        content: myStore.appConfig.brandDescription,
      },
    ],
  },
};

import Navbar from "@/components/layout/Navbar.vue";
import Github from "@/components/organization/logo/github.vue";
import CustomNetwork from "@/components/network/tools/modify-network.vue";
import { BAlert, BIconEnvelope } from "bootstrap-vue";
import { isString } from "@stellarbeat/js-stellarbeat-shared/lib/typeguards";
import useStore from "@/store/useStore";
import { computed, nextTick, onBeforeMount, ref, watch } from "vue";
import { useRoute } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'App',
  setup(__props) {

const errorMessage = ref("Could not connect to api, please refresh the page");

const store = useStore();
const showError = store.fetchingDataFailed;
const route = useRoute();

const getNetworkIdFromQueryParam = (
  networkQueryParameter: string | (string | null)[]
): string | null => {
  if (isString(networkQueryParameter)) return networkQueryParameter;
  return null;
};

const networkId = computed(() => {
  return getNetworkIdFromQueryParam(route.query.network);
});

const timeTravelDate = computed(() => {
  return store.getDateFromParam(route.query.at);
});

onBeforeMount(async () => {
  await store.updateNetwork(networkId.value, timeTravelDate.value);
});

watch(
  [networkId, timeTravelDate],
  async () => {
    if (!store.networkNeedsToBeUpdated(networkId.value, timeTravelDate.value))
      return;

    store.isLoading = true;
    nextTick(async () => {
      //next tick is needed to toggle the loading state. The loading state is needed to clean up the previous gui.
      await store.updateNetwork(networkId.value, timeTravelDate.value);
    });
  },
  { immediate: false, deep: true }
);

return { __sfc: true,myStore, errorMessage, store, showError, route, getNetworkIdFromQueryParam, networkId, timeTravelDate, Navbar, Github, CustomNetwork, BAlert, BIconEnvelope }
}

})